exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ComponentDemonstrator .demo{transition:left .5s;float:left}.ComponentDemonstrator.slideLeft{left:0}.ComponentDemonstrator .questionFeedbackBox{position:relative;float:right;left:10%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/students/onboarding/component_demonstrator.scss
// module id = 1427
// module chunks = 0